import React from "react";
import PropTypes from "prop-types";

import { useStreamTagController } from "../../hooks";
import { Dropdown, MultipleClientDropdown } from "..";

export function StreamTagCondition({
  disabled,
  id,
  operand,
  streams,
  tags,
  parameters,
}) {
  const { operandProps, streamTagProps } = useStreamTagController({
    id,
    operand,
    parameters,
    streams,
    tags,
  });

  return (
    <div data-test="stream-tag-condition" style={{ display: "flex" }}>
      <div style={{ width: 200 }}>
        <Dropdown
          disableClearable
          includeInputInList
          data-test="stream-tag-operand-dropdown"
          disabled={disabled}
          {...operandProps}
        />
      </div>
      <div style={{ marginLeft: 16 }}>
        <MultipleClientDropdown
          data-test="stream-tag-dropdown"
          placeholder="Select streams or tags"
          showStreams
          showTags
          disabled={disabled}
          name="streamsTags"
          dropdownStyle={{ width: 300, marginBottom: 0 }}
          {...streamTagProps}
        />
      </div>
    </div>
  );
}

StreamTagCondition.propTypes = {
  id: PropTypes.string.isRequired,
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      operands: PropTypes.array,
    })
  ).isRequired,
  disabled: PropTypes.bool,
  streams: PropTypes.array,
  tags: PropTypes.array,
  operand: PropTypes.string,
};

StreamTagCondition.defaultProps = {
  operand: "contains any of",
  disabled: false,
  streams: [],
  tags: [],
};

export default StreamTagCondition;
